import React from 'react'
import { NumberInput, NumberInputProps, useGetOne } from 'react-admin'
import { MainProductAPIEntity } from 'services/api/entities'
import { ServicesConfig } from 'services/api/entities/servicesconfig'
import { useKResource } from 'services/hooks/useKResource'
import { validateBookingTimeLimit } from 'services/utils/validation'
import { CustomFormProps } from 'types/common'
import KToolTip from 'ui-shared/KTooltip'

type Props = Omit<NumberInputProps, 'source'> & CustomFormProps

const BookingTimeLimitInput: React.FC<Props> = () => {
  const { data: servicesConfig } = useGetOne<ServicesConfig>('servicesconfig', {
    id: 'servicesconfig',
  })
  const resource = useKResource<MainProductAPIEntity>()

  if (!servicesConfig) return null

  return (
    <KToolTip title="tooltip.hint.bookingTimeLimit">
      <NumberInput
        source="advanceReservationMin"
        label="form.fields.bookingTimeLimit"
        fullWidth
        defaultValue=""
        validate={validateBookingTimeLimit(resource, servicesConfig)}
      />
    </KToolTip>
  )
}

export default BookingTimeLimitInput
